<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label for="report_option_date_start">Date Start</label>
        <input
          id="report_option_date_start"
          v-model="value.start"
          type="date"
          class="form-control"
        />
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label for="report_option_date_end">Date End</label>
        <input
          id="report_option_date_end"
          v-model="value.end"
          type="date"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Object,
    },
  },

  mounted() {
    this.$emit("loaded");
    this.$emit("completed");
  },
};
</script>
